import { combineReducers } from "redux";
import { SET_ADDING_EMAIL, RESET_ADDING_EMAIL } from "./settingConstants";

export function isAddingEmail(state = false, action) {
  switch (action.type) {
    case SET_ADDING_EMAIL:
      return true;
    case RESET_ADDING_EMAIL:
      return false;
    default:
      return state;
  }
}

export default combineReducers({
  isAddingEmail,
});
